import { computed, observable } from 'mobx';

import BaseDashboardView from './BaseDashboardView';
import WeekStore from '../api/WeekStore';


class BaseWeekStoreDashboardView extends BaseDashboardView {
  static model = WeekStore;

  @observable weekStores = [];
  @observable weekStoreId = null;

  getQueryParams() {
    return {
      week_store: this.weekStoreId,
      ...super.getQueryParams(),
    };
  }

  @computed get weekStore() {
    if (this.weekStoreId === null) {
      return null;
    }
    return WeekStore.getForId(this.weekStoreId);
  }

  async ajaxRequest(method, subPath, config) {
    this.weekStores = await WeekStore.getList({});
    if (this.weekStoreId === null) {
      this.weekStoreId = this.weekStores[0].id;
    }
    return await this.weekStore.ajaxRequest(method, subPath, config);
  }

  onWeekStoreIdChange = this.genericChangeValueHandler('weekStoreId');

  @computed get weekStoreOptions() {
    return this.weekStores.map(weekStore => ({ value: weekStore.id, display_name: weekStore.toString() }));
  }

  get weekStoreField() {
    if (this.weekStoreId === null) {
      return null;
    }
    return this.renderAutocomplete(
      'Week version',
      this.weekStoreOptions,
      this.weekStoreId,
      this.onWeekStoreIdChange,
      250,
    );
  }
}


export default BaseWeekStoreDashboardView;
